import Model, { belongsTo, hasMany } from "@ember-data/model";
import type ModelRegistry from "@ember-data/types/registries/model";
import type ConsultationAllowedType from "./consultation-allowed-type";
import type ConsultationReportType from "./consultation-report-type";
import type TherapeuticalArea from "./therapeutical-area";
export default class FollowUpReason extends Model {
  @hasMany("consultation-allowed-type", {
    async: false,
    inverse: "followUpReasons"
  })
  declare consultationAllowedTypes: ConsultationAllowedType[];
  @hasMany("consultation-report-type", {
    async: false,
    inverse: "followUpReasons"
  })
  declare consultationReportTypes: ConsultationReportType[];
  @belongsTo("therapeutical-area", { async: false, inverse: "followUpReasons" })
  declare therapeuticalArea: TherapeuticalArea;

  get adverseEvents(): ModelRegistry["adverse-event"][] {
    if (this.#specificAdverseEvents.length > 0) {
      return this.#specificAdverseEvents;
    }
    return this.therapeuticalArea.adverseEvents.slice();
  }

  set adverseEvents(array: ModelRegistry["adverse-event"][]) {
    this.#specificAdverseEvents = array;
  }

  get patho(): string {
    // for pathologies like onco-generic, since just "generic" isn't enough
    if (this.id.endsWith("generic")) return this.id;
    return this.id.split("-").splice(1).join("-");
  }

  #specificAdverseEvents: ModelRegistry["adverse-event"][] = [];

  /**
   * A follow-up reason `<therapeutical area>-generic` (e.g. `nephro-generic`)
   * means that the follow-up reason is not specified ("Non précisé").
   * `generic-general` is not one of them: it is the follow-up reason "general"
   * of the therapeutical area `generic` ("Suivi général").
   */
  static isGeneric(id: string | undefined): boolean {
    return id?.endsWith("-generic") ?? false;
  }
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "follow-up-reason": FollowUpReason;
  }
}
